import { render, staticRenderFns } from "./FantasySlide.vue?vue&type=template&id=e6bb554c&"
import script from "./FantasySlide.vue?vue&type=script&lang=js&"
export * from "./FantasySlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports